import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/* Ext Library imports*/
import { InputText } from "primeng/inputtext";
import { Textarea } from 'primeng/textarea';
import { Panel } from 'primeng/panel';
import { Button } from 'primeng/button';
import { DatePicker } from 'primeng/datepicker';
import { FloatLabel } from 'primeng/floatlabel';
import { Checkbox } from 'primeng/checkbox';
import { ColorPicker } from 'primeng/colorpicker';
import { Select } from 'primeng/select';
import { XiroccoSelectDefaultsDirective } from '../theme/xirocco-select-defaults.directive';
import { XiroccoDatepickerButtonBarDirective } from '../theme/xirocco-datepicker-defaults.directive';
import { Editor } from 'primeng/editor';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { InputNumber } from 'primeng/inputnumber';
import { Password } from 'primeng/password';
import { Divider } from 'primeng/divider';
import { RadioButton } from 'primeng/radiobutton';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService, PrimeTemplate } from 'primeng/api';
import { Card } from 'primeng/card';
import { Dialog } from 'primeng/dialog';
import { Drawer } from 'primeng/drawer';
import { Tooltip } from 'primeng/tooltip';
import { FileUpload } from 'primeng/fileupload';
import { UIChart } from 'primeng/chart';
import { Message } from 'primeng/message';
import { Toast } from 'primeng/toast';
import { Avatar } from 'primeng/avatar';
import { AvatarGroup } from 'primeng/avatargroup';
import { Chip } from 'primeng/chip';
import { ProgressSpinner } from 'primeng/progressspinner';
import { InputComponent } from './components/input/input.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { InputnumbersComponent } from './components/inputnumbers/inputnumbers.component';
import { InputswitchComponent } from './components/inputswitch/inputswitch.component';
import { TexteditorComponent } from './components/texteditor/texteditor.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { RadioComponent } from './components/radio/radio.component';
import { ColorpickerComponent } from './components/colorpicker/colorpicker.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { PasswordComponent } from './components/password/password.component';
import { ChipsComponent } from './components/chips/chips.component';
import { InputchipsComponent } from './components/inputchips/inputchips.component';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { ButtonComponent } from './components/button/button.component';
import { IconbuttonComponent } from './components/iconbutton/iconbutton.component';
import { PanelComponent } from './components/panel/panel.component';
import { CardComponent } from './components/card/card.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { SplitterComponent } from './components/splitter/splitter.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { ConfirmdialogComponent } from './components/confirmdialog/confirmdialog.component';
import { ModaldialogComponent } from './components/modaldialog/modaldialog.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { UploadComponent } from './components/upload/upload.component';
import { MenuComponent } from './components/menu/menu.component';
import { HorizontalStackedBarChartComponent } from './components/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.component';
import { PiechartComponent } from './components/piechart/piechart.component';
import { DonutchartComponent } from './components/donutchart/donutchart.component';
import { LinechartComponent } from './components/linechart/linechart.component';
import { ToastComponent } from './components/toast/toast.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { ProgressbarComponent } from './components/progressbar/progressbar.component';
import { InputHeaderComponent } from './components/input-header/input-header.component';
import { InputFooterComponent } from './components/input-footer/input-footer.component';
import { InputSidenavComponent } from './components/input-sidenav/input-sidenav.component';
import { SwotmatrixComponent } from './components/swotmatrix/swotmatrix.component';
import { HeatmapComponent } from './components/heatmap/heatmap.component';
import { HMapComponent } from './components/hmap/hmap.component';
import { OrgchartComponent } from './components/orgchart/orgchart.component';
import { LoopBackComponent } from './components/loop-back/loop-back.component';
import { CanvasComponent } from './components/canvas/canvas.component';
import { openimageuploadpopupComponent } from './components/popup/openimageuploadpopup.component';
import { SafePipe } from '../utils/safe.pipe';
import { HeatmapobservationsComponent } from './heatmapobservations/heatmapobservations.component';

import { ExecsummaryComponent } from '../modules/presentation/modules/itdiagnostic/components/execsummary/execsummary.component';
import { NeedforchangeComponent } from '../modules/presentation/modules/itdiagnostic/components/needforchange/needforchange.component';
import { ItswotmatrixComponent } from '../modules/presentation/modules/itdiagnostic/components/itswotmatrix/itswotmatrix.component';
import { KeyfindingsComponent } from '../modules/presentation/modules/itdiagnostic/components/keyfindings/keyfindings.component';
import { DatahmComponent } from '../modules/presentation/modules/itdiagnostic/components/datahm/datahm.component';
import { CyberhmComponent } from '../modules/presentation/modules/itdiagnostic/components/cyberhm/cyberhm.component';
import { ItcaphmComponent } from '../modules/presentation/modules/itdiagnostic/components/itcaphm/itcaphm.component';
import { ItinfrahmComponent } from '../modules/presentation/modules/itdiagnostic/components/itinfrahm/itinfrahm.component';
import { CriticalapphmComponent } from '../modules/presentation/modules/itdiagnostic/components/criticalapphm/criticalapphm.component';
import { VisonobjectiveComponent } from './visionobjective/visionobjective.component';
import { ColorPickerDirective, ColorPickerComponent } from 'ngx-color-picker';
import { VisiongoalsComponent } from './visiongoals/visiongoals.component';
import { ITVisiongoalsComponent } from './itvisiongoals/itvisiongoals.component';
import { TableModule } from 'primeng/table';
import { NumberSuffixPipe } from './number-suffix.pipe';
import { HmapobservationsComponent } from './hmapobservations/hmapobservations.component';
import { OutputHmObservationsComponent } from './output-hm-observations/output-hm-observations.component';
import { SafeHtmlPipe } from './dom-sanitizer';
import { ThemeAlignComponent } from './theme-align/theme-align.component';
import { PortfolioThemePopupComponent } from './portfolio-theme-popup/portfolio-theme-popup.component';
import { NarrativePopupComponent } from './narrative-popup/narrative-popup.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ObjsharedPopupComponent } from './objshared-popup/objshared-popup.component';
import { ExesumpComponent } from './print/exesump/exesump.component';
import { NeedforchngpComponent } from './print/needforchngp/needforchngp.component';
import { ItswotpComponent } from './print/itswotp/itswotp.component';
import { ImageFallbackDirective } from '../directives/image-fallback.directive';
import { ApplicationdataPopupComponent } from './applicationdata-popup/applicationdata-popup.component';
import { FilterComponent } from './components/filter/filter.component';
import { MappingCardPopupComponent } from './components/mapping-card-popup/mapping-card-popup.component';
import { MarkdownModule } from 'ngx-markdown';
import { MultiSelect } from 'primeng/multiselect';
import { JointJsCanvasModule } from 'src/app/shared/components/jointjscanvas/jointjscanvas.module';
import { CookieModule } from 'ngx-cookie';
import { CookieService } from 'ngx-cookie-service';
import { HighchartsChartComponent } from 'highcharts-angular';

@NgModule({
  providers: [MessageService, CookieService],
  declarations: [
    ImageFallbackDirective,
    InputComponent,
    TextareaComponent,
    InputnumbersComponent,
    InputswitchComponent,
    TexteditorComponent,
    CheckboxComponent,
    RadioComponent,
    ColorpickerComponent,
    DropdownComponent,
    PasswordComponent,
    ChipsComponent,
    InputchipsComponent,
    MultiselectComponent,
    CalendarComponent,
    ButtonComponent,
    IconbuttonComponent,
    PanelComponent,
    CardComponent,
    AccordionComponent,
    SplitterComponent,
    TabsComponent,
    ConfirmdialogComponent,
    ModaldialogComponent,
    SidebarComponent,
    TooltipComponent,
    UploadComponent,
    MenuComponent,
    HorizontalStackedBarChartComponent,
    PiechartComponent,
    DonutchartComponent,
    LinechartComponent,
    ToastComponent,
    AvatarComponent,
    ProgressbarComponent,
    InputHeaderComponent,
    InputFooterComponent,
    InputSidenavComponent,
    SwotmatrixComponent,
    HeatmapComponent,
    HMapComponent,
    LoopBackComponent,
    OrgchartComponent,
    CanvasComponent,
    openimageuploadpopupComponent,
    SafePipe,
    HeatmapobservationsComponent,
    VisonobjectiveComponent,
    ApplicationdataPopupComponent,
    VisiongoalsComponent,
    HmapobservationsComponent,
    OutputHmObservationsComponent,
    ITVisiongoalsComponent,
    SafeHtmlPipe,
    NumberSuffixPipe,
    ThemeAlignComponent,
    PortfolioThemePopupComponent,
    NarrativePopupComponent,
    ObjsharedPopupComponent,
    ExesumpComponent,
    NeedforchngpComponent,
    ItswotpComponent,
    FilterComponent,
    MappingCardPopupComponent,
    // ExecsummaryComponent,
    // NeedforchangeComponent,
    // ItswotmatrixComponent,
    // KeyfindingsComponent,
    // ItcaphmComponent,
    // ItinfrahmComponent,
    // DatahmComponent,
    // CyberhmComponent,
    // CriticalapphmComponent
  ],
  imports: [
    HighchartsChartComponent,
    CommonModule,
    FormsModule,
    InputText,
    Textarea,
    Panel,
    Button,
    DatePicker,
    FloatLabel,
    Checkbox,
    ColorPicker,
    Select,
    XiroccoSelectDefaultsDirective,
    XiroccoDatepickerButtonBarDirective,
    Editor,
    ToggleSwitch,
    InputNumber,
    Password,
    Divider,
    RadioButton,
    ConfirmDialog,
    Dialog,
    Drawer,
    Tooltip,
    FileUpload,
    UIChart,
    Message,
    Toast,
    Avatar,
    AvatarGroup,
    Chip,
    ProgressSpinner,
    Card,
    ColorPickerDirective,
    ColorPickerComponent,
    TableModule,
    DragDropModule,
    MultiSelect,
    MarkdownModule,
    JointJsCanvasModule,
    CookieModule,
    PrimeTemplate
  ],
  exports: [
    CommonModule,
    FormsModule,
    Select,
    Editor,
    DatePicker,
    Toast,
    ImageFallbackDirective,
    SafePipe,
    VisiongoalsComponent,
    VisonobjectiveComponent,
    InputComponent,
    TextareaComponent,
    InputnumbersComponent,
    InputswitchComponent,
    TexteditorComponent,
    CheckboxComponent,
    RadioComponent,
    ColorpickerComponent,
    DropdownComponent,
    PasswordComponent,
    ChipsComponent,
    InputchipsComponent,
    MultiselectComponent,
    CalendarComponent,
    ButtonComponent,
    IconbuttonComponent,
    PanelComponent,
    CardComponent,
    AccordionComponent,
    SplitterComponent,
    TabsComponent,
    ConfirmdialogComponent,
    ModaldialogComponent,
    SidebarComponent,
    TooltipComponent,
    UploadComponent,
    MenuComponent,
    HorizontalStackedBarChartComponent,
    PiechartComponent,
    DonutchartComponent,
    LinechartComponent,
    ToastComponent,
    AvatarComponent,
    ProgressbarComponent,
    SwotmatrixComponent,
    HeatmapComponent,
    HMapComponent,
    LoopBackComponent,
    OrgchartComponent,
    CanvasComponent,
    openimageuploadpopupComponent,
    ITVisiongoalsComponent,
    SafeHtmlPipe,
    NumberSuffixPipe,
    ThemeAlignComponent,
    PortfolioThemePopupComponent,
    NarrativePopupComponent,
    FilterComponent,
    MappingCardPopupComponent,
    MarkdownModule,
    // ExecsummaryComponent,
    // NeedforchangeComponent,
    // ItswotmatrixComponent,
    // KeyfindingsComponent,
    CookieModule,
    FloatLabel,
    XiroccoSelectDefaultsDirective,
    XiroccoDatepickerButtonBarDirective,
    PrimeTemplate
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
